import Gate from "@pathwright/ui/src/components/gate/Gate"
import Gates from "@pathwright/ui/src/components/gate/Gates"
import withTranslate from "@pathwright/ux/src/components/lng/withTranslate"
import LazyAdaptedAuthContainer from "@pathwright/features/src/modules/auth/LazyAdaptedAuthContainer"
import { OrderSubscriptionFlow } from "@pathwright/features/src/modules/order/OrderSubscriptionCard"
import { usePathwrightContext } from "@pathwright/features/src/modules/pathwright/PathwrightContext"
import { ENROLLMENT_ROLE_TEACHER } from "invitation/constants"
import { ConnectStores } from "lib/core/store"
import { OFFERING_OPTION_IN_PLAN } from "library/register/constants"
import { useRef, useState } from "react"
// import SignInContainer from "../../../../../../client/src/views/auth/sign-in/SignInContainer"
import SignedInFooter from "./SignedInFooter"

const SubscribeGate = ({
  offering,
  inviteToken,
  userPropertyDefaults,
  redirectTo
}) => (
  <OrderSubscriptionFlow
    planIds={offering.include_in_subscription_plans}
    productIds={offering.include_with_products}
    inviteToken={inviteToken}
    userPropertyDefaults={userPropertyDefaults}
    redirectTo={redirectTo}
  />
)

const RegisterAuthGate = ({
  register,
  requiresSubscription,
  offering,
  resource,
  unlockMessage,
  invitation,
  sso,
  truncatedSchoolName,
  promo,
  inviteToken,
  redirectTo,
  offerConversionActionLabel,
  attemptToConvert,
  t
}) => {
  const { me, school } = usePathwrightContext()
  const initiallyAuthenticated = useRef(!!me).current

  const treatAsHavingSignedIn = attemptToConvert && me
  const [signedIn, setSignedIn] = useState(treatAsHavingSignedIn)
  const handleSignedIn = () => setSignedIn(true)

  const userPropertyDefaults = {
    firstName: (invitation && invitation.extra.first_name) || null,
    lastName: (invitation && invitation.extra.last_name) || null,
    email: (invitation && invitation.extra.to_email) || null
  }

  const authContainerProps = {
    userPropertyDefaults,
    inviteToken,
    onComplete: handleSignedIn
  }

  if (signedIn) {
    return (
      <SignedInFooter
        attemptToConvert={attemptToConvert}
        offerConversionActionLabel={offerConversionActionLabel}
      />
    )
  }

  if (
    initiallyAuthenticated ||
    (invitation && invitation.offering_registration) ||
    !sso.pathwright_login_enabled
  ) {
    return <LazyAdaptedAuthContainer {...authContainerProps} />
  }

  if (requiresSubscription) {
    return (
      <Gates className="RegisterAuthGate">
        <Gate
          line1={t("registration.auth_gate.have_subscription")}
          line2={t("registration.auth_gate.sign_in")}
          gate={<LazyAdaptedAuthContainer {...authContainerProps} />}
        />
        <Gate
          line1={t("registration.auth_gate.no_subscription")}
          line2={t("registration.auth_gate.create_a_subscription", {
            school_name: school.name
          })}
          gate={
            <SubscribeGate
              offering={offering}
              inviteToken={inviteToken}
              userPropertyDefaults={userPropertyDefaults}
              redirectTo={redirectTo}
            />
          }
        />
      </Gates>
    )
  }

  return <LazyAdaptedAuthContainer {...authContainerProps} />
}

RegisterAuthGate.displayName = "RegisterAuthGate"

const mapStateToProps = (state, ownProps) => {
  const { t } = ownProps

  let unlockMessage
  const { offering_option, offering, resource, invitation } =
    state.registerStore.state
  const { register } = state.registerStore.action
  const { school, integrations } = state.schoolStore.state

  const requiresSubscription =
    offering_option === OFFERING_OPTION_IN_PLAN &&
    !(invitation && invitation.role === ENROLLMENT_ROLE_TEACHER)

  if (invitation != null ? invitation.offering_registration : undefined) {
    unlockMessage = `${t("registration.auth_gate.only_for")} ${
      invitation.offering_registration.user.email
    }`
  } else if (requiresSubscription) {
    unlockMessage = t("registration.auth_gate.only_for_subscribers")
  } else {
    unlockMessage = t("registration.auth_gate.only_for_members")
  }

  const truncatedSchoolName = state.schoolStore.request.truncatedName()

  return _.assign(
    {},
    {
      register,
      offering,
      resource,
      unlockMessage,
      requiresSubscription,
      invitation,
      sso: integrations.sso,
      truncatedSchoolName
    },
    ownProps
  )
}

const stores = [
  { store: "register", watch: ["invitation"] },
  { store: "school", watch: false }
]

export default withTranslate(
  ConnectStores(RegisterAuthGate, stores, {}, mapStateToProps)
)
